import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header, CardSectionHeader, PDFSvg, StatusTable, Row, MultiLink } from "@egovernments/digit-ui-react-components";
// import ApplicationDetailsProffessional from "../../../../../templates/ApplicationDetails";
import { downloadAndPrintReciept } from "../../../utils";
import { Card } from "@material-ui/core";
import HouseIcon from "@mui/icons-material/House";
import ApplicationDetailsProffessional from "../../../../../templates/ApplicationDetails/formProffessional";

const ProfessionalApplicationDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = tenantId?.split(".")[0];
  const [showToast, setShowToast] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const { isLoading, data: applicationDetails } = Digit.Hooks.obps.useLicenseDetails(
    tenantId,
    { applicationNumber: id },
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      // refetchOnWindowFocus: true,
      // refetchOnReconnect: true,
    }
  );
  const isMobile = window.Digit.Utils.browser.isMobile();

  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate,
  } = Digit.Hooks.obps.useBPAREGApplicationActions();

  const workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: "BPAREG",
  });

  const closeToast = () => {
    setShowToast(null);
  };

  let dowloadOptions = [];

  if (applicationDetails?.payments?.length > 0) {
    dowloadOptions.push({
      label: t("TL_RECEIPT"),
      onClick: () =>
        downloadAndPrintReciept(
          applicationDetails?.payments?.[0]?.paymentDetails?.[0]?.businessService || "BPAREG",
          applicationDetails?.applicationData?.applicationNumber,
          applicationDetails?.applicationData?.tenantId
        ),
    });
  }

  return (
    <div className={"employee-main-application-details"}>
      {/* <div  className={"employee-application-details"}>
        <Header>{t("CS_TITLE_APPLICATION_DETAILS")}</Header>
        {applicationDetails?.payments?.length > 0 && 
        <MultiLink
          className="multilinkWrapper employee-mulitlink-main-div"
          onHeadClick={() => setShowOptions(!showOptions)}
          displayOptions={showOptions}
          options={dowloadOptions}
          downloadBtnClassName={"employee-download-btn-className"}
          optionsClassName={"employee-options-btn-className"}
        />}
        </div> */}
      {!isLoading && applicationDetails && (
        <React.Fragment>
          {/* <Card style={{margin: "15px 0px 15px",padding: "8px" , position: "relative" }} className={"employeeCard-override"}>
           <HouseIcon style={{ color: 'red' }} /> Take Action</Card> */}

          <ApplicationDetailsProffessional
            applicationDetails={applicationDetails}
            isLoading={isLoading}
            isDataLoading={isLoading}
            applicationData={applicationDetails?.applicationData}
            mutate={mutate}
            workflowDetails={workflowDetails}
            businessService={
              workflowDetails?.data?.applicationBusinessService
                ? workflowDetails?.data?.applicationBusinessService
                : applicationDetails?.applicationData?.businessService
            }
            moduleCode="BPAREG"
            showToast={showToast}
            setShowToast={setShowToast}
            ActionBarStyle={isMobile ? {} : { paddingRight: "50px" }}
            MenuStyle={isMobile ? {} : { right: "50px" }}
            closeToast={closeToast}
            timelineStatusPrefix={`WF_${
              workflowDetails?.data?.applicationBusinessService
                ? workflowDetails?.data?.applicationBusinessService
                : applicationDetails?.businessService
            }_`}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default ProfessionalApplicationDetail;
